import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardHeader } from '@/components/NCCard/NCCard';
import { EcologicalIntegrityExplainerBU } from '@/components/NCExplainers/EcologicalIntegrityExplainer';

import { GraphTile } from './components/GraphTile';
import { StatsTile } from './components/StatsTile';

export const EcologicalIntegrityCard = () => {
  const { t } = useTranslation();

  return (
    <NCCard explainer={<EcologicalIntegrityExplainerBU />}>
      <NCCardHeader
        title={t('shared.ncaDetail.ecologicalIntegrity.historicalDataBU.title')}
        className='lg:grid-cols-[1fr_1fr]'
      />
      <NCCard2SectionLayout className='[&>*]:py-8'>
        <GraphTile />
        <StatsTile />
      </NCCard2SectionLayout>
    </NCCard>
  );
};
